var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldShow)?_c('div',{staticClass:"upgrade alert alert-warning"},[_c('router-link',{staticClass:"upgrade__title",attrs:{"tag":"div","to":{ name : 'thirdparty.scholarpack' }}},[_vm._v(_vm._s(_vm.$t('upgrade-notice.title')))])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9f9b9b80","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/appsList/cards/admin/UpgradeNotice.vue
// module id = null
// module chunks = 